import React from "react";
import { Breadcrumb } from "components/ui/BootstrapCompat";
import useLocalStorage from "helpers/useLocalStorage";
import WalletSummaryCards from "./components/WalletSummaryCards";
import WalletTableSection from "./components/WalletTableSection";

type Props = {};

export default function WalletPage({}: Props) {
  const [searchTerm, setSearchTerm] = React.useState("");
  const [filterType, setFilterType] = React.useState("all");
  const [filterStatus, setFilterStatus] = React.useState("all");
  const [dateFrom, setDateFrom] = React.useState("");
  const [dateTo, setDateTo] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [token] = useLocalStorage("token", "");
  const [businessId] = useLocalStorage("businessId", "");

  return (
    <div className="min-w-0">
      <Breadcrumb>
        <Breadcrumb.Item active>ເຄື່ອງມືພື້ນຖານ</Breadcrumb.Item>
        <Breadcrumb.Item active>Transaction</Breadcrumb.Item>
      </Breadcrumb>

      {/* <WalletSummaryCards
        token={token || ""}
        businessId={businessId || ""}
        filterType={filterType}
        filterStatus={filterStatus}
        dateFrom={dateFrom}
        dateTo={dateTo}
      /> */}

      <WalletTableSection
        token={token || ""}
        businessId={businessId || ""}
        searchTerm={searchTerm}
        onSearchTermChange={setSearchTerm}
        filterType={filterType}
        onFilterTypeChange={setFilterType}
        filterStatus={filterStatus}
        onFilterStatusChange={setFilterStatus}
        dateFrom={dateFrom}
        onDateFromChange={setDateFrom}
        dateTo={dateTo}
        onDateToChange={setDateTo}
        page={page}
        onPageChange={setPage}
      />
    </div>
  );
}
